import {ClientErrorType} from "./client.error.type";
import {ClientErrorCode} from "./client.error.code";

export class ClientErrorResponse {

    private _type: ClientErrorType;
    private _status: number;
    private _errorCode: ClientErrorCode;
    private _errorMessage: string;
    private _errorArguments: {};
    private _emailws: string;


    get emailws(): string {
        return this._emailws;
    }

    set emailws(value: string) {
        this._emailws = value;
    }

    get type(): ClientErrorType {
        return this._type;
    }

    set type(value: ClientErrorType) {
        this._type = value;
    }

    get status(): number {
        return this._status;
    }

    set status(value: number) {
        this._status = value;
    }

    get errorCode(): ClientErrorCode {
        return this._errorCode;
    }

    set errorCode(value: ClientErrorCode) {
        this._errorCode = value;
    }

    get errorMessage(): string {
        return this._errorMessage;
    }

    set errorMessage(value: string) {
        this._errorMessage = value;
    }

    get errorArguments(): {} {
        return this._errorArguments;
    }

    set errorArguments(value: {}) {
        this._errorArguments = value;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/core/http/entity/client.error.response.ts